import { all } from 'redux-saga/effects';

import createSaga from './Create/saga';
import editSaga from './Edit/saga';

export default function* (context) {
  yield all([createSaga(), editSaga()]);
}
